// import React, { useEffect, useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import CssBaseline from "@mui/material/CssBaseline";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import logo from "../assets/plogo.png";

// import { Popover, Transition } from "@headlessui/react";

// import { useLocation, useNavigate } from "react-router-dom";
// import { IoIosArrowDown } from "react-icons/io";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import MedicationIcon from "@mui/icons-material/Medication";
// import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import GroupsIcon from "@mui/icons-material/Groups";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import StorefrontIcon from "@mui/icons-material/Storefront";

// import Inventory2Icon from "@mui/icons-material/Inventory2";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import toast from "react-hot-toast";
// import Cookies from "js-cookie";

// // import {
// //   SESSION_IS_AUTHENTICATED,
// //   SESSION_USERINFO,
// // } from "../Utills/Constants";

// const drawerWidth = 240;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function PortalLayout({ children }) {
//   const theme = useTheme();
//   const [open, setOpen] = useState(true);
//   const [isOpen, setIsOpen] = useState(false);
//   //const [auth, setAuth] = useState(sessionStorage.getItem(SESSION_IS_AUTHENTICATED));
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showAccounts, setShowAccounts] = useState(false)

//   const handleDrawer = () => {
//     setOpen(!open);
//   };

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     Cookies.remove("RVkXIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1L=");
//     toast.success("Logout Successfully");
//     navigate("/login", { replace: true });
//   };

//   const [userEmail, setUserEmail] = useState("");

//   useEffect(() => {
//     const email = sessionStorage.getItem("userEmail");
//     if (email) {
//       setUserEmail(email);
//     }
//   }, []);

//   return (
//     <>
//       {location.pathname === "/" ? (
//         children
//       ) : (
//         <>
//           <div className=" !flex !items-center">
//             <CssBaseline />
//             <AppBar
//               className={`!bg-[#ffffff] !rounded-md !shadow-none mt-[-7px] ml-3 -z-50 ${
//                 open ? `!w-[84%]"` : `!w-[96%]`
//               }`}
//               sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
//               open={open}
//             >
//               <Toolbar>
//                 <IconButton
//                   aria-label="open drawer"
//                   onClick={handleDrawer}
//                   edge="start"
//                   sx={{ marginLeft: 1 }}
//                 >
//                   <MenuIcon className="text-gray-600 mt-[4px]" />
//                 </IconButton>
//                 <div className="ml-auto flex gap-2 items-center">
//                   <div className="flex items-center gap-2">
//                     <AccountCircleIcon
//                       className="text-gray-600 "
//                       sx={{ fontSize: 22 }}
//                     />
//                     <Popover className="ml-auto">
//                       <Popover.Button
//                         onClick={toggleMenu}
//                         className="flex gap-2 outline-none md:mr-6 cursor-pointer text-gray-700"
//                       >
//                         <IoIosArrowDown
//                           className={`w-4 h-4 ${
//                             isOpen
//                               ? "-rotate-180 duration-300"
//                               : "rotate-0 duration-300"
//                           }`}
//                         />
//                       </Popover.Button>
//                       <Transition
//                         as={React.Fragment}
//                         enter="transition ease-out duration-100"
//                         enterFrom="transform scale-95"
//                         enterTo="transform scale-100"
//                         leave="transition ease-in duration-75"
//                         leaveFrom="transform scale-100"
//                         leaveTo="transform scale-95"
//                       >
//                         <Popover.Panel className="absolute right-10 bg-gray-50 border-2 border-gray-300 shadow-lg rounded-md w-[150px] text-black">
//                           <div>
//                             <div
//                               className="flex text-gray-600 gap-6 p-2 cursor-pointer"
//                               onClick={handleLogout}
//                             >
//                               <PowerSettingsNewIcon className="text-gray-600" />
//                               <h1>LogOut</h1>
//                             </div>
//                           </div>
//                         </Popover.Panel>
//                       </Transition>
//                     </Popover>
//                   </div>
//                 </div>
//               </Toolbar>
//             </AppBar>
//             <Drawer
//               variant="permanent"
//               open={open}
//               sx={{
//                 flexShrink: 0,
//                 "& .MuiDrawer-paper": {
//                   borderWidth: 0,
//                   boxSizing: "border-box",

//                   borderBottomRightRadius: 15,
//                   backgroundColor: "#fff",
//                   zIndex: "9999",
//                   boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)",
//                 },
//                 border: "none",
//               }}
//             >
//               <div>
//                 <img
//                   src={logo}
//                   alt=""
//                   className={`${
//                     open ? "w-[6rem]" : "w-[5rem]"
//                   } ml-auto mr-auto my-4`}
//                 />
//               </div>
//               <div>
//                 <ul className="w-[100%]">
//                   <li>
//                     <div
//                       onClick={() => navigate("/pos")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/pos"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <PointOfSaleIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/pos"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/pos"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         POS
//                       </span>
//                     </div>
//                   </li>
//                   <li>
//                     <div
//                       onClick={() => navigate("/products")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/products"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <MedicationIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/products"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/products"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Stock
//                       </span>
//                     </div>
//                   </li>
//                   <li>
//                     <div
//                       onClick={() => navigate("/sales")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/sales"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <PointOfSaleIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/sales"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/sales"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Sales
//                       </span>
//                     </div>
//                   </li>
//                   <li>
//                     <div
//                       onClick={() => navigate("/salesreturn")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/salesreturn"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <PointOfSaleIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/salesreturn"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/salesreturn"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Sales Return
//                       </span>
//                     </div>
//                   </li>
//                   <li>
//                     <div
//                       onClick={() => navigate("/purchases")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/purchases"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <ShoppingBagIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/purchases"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/purchases"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Purchases
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => navigate("/suppliers")}
//                       className={`flex items-center p-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/suppliers"
//                           ? "bg-primary text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       } ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <StorefrontIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/suppliers"
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/suppliers"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Suppliers
//                       </span>
//                     </div>
//                   </li>
//                   <li>
//                     <div
//                       onClick={() => setShowAccounts(!showAccounts)}
//                       className={`flex items-center p-2 mr-2 cursor-pointer text-gray-600 mt-3 h-[2.6rem] transition-all duration-300
//                         ${
//                           location.pathname.startsWith("/accounts")
//                             ? "bg-primary text-white font-[600] rounded-md"
//                             : ""
//                         }
//                         ${open ? "ml-6" : "ml-0"}`}
//                     >
//                       <MedicationIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname.startsWith("/accounts")
//                             ? "bg-primary text-white"
//                             : ""
//                         }`}
//                         sx={{
//                           boxShadow: location.pathname.startsWith("/accounts")
//                             ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                             : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600] text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Cash Details
//                       </span>
//                     </div>

//                     {/* Subfolder Items */}
//                     {showAccounts && open && (
//                       <ul className="ml-12 mt-2 space-y-1">
//                         <li
//                           onClick={() => navigate("/accounts")}
//                           className={`cursor-pointer text-gray-600 w-[80%] text-xs font-bold p-2 pl-4 rounded-md ${
//                             location.pathname === "/accounts"
//                               ? "bg-primary text-white"
//                               : "hover:bg-gray-100"
//                           }`}
//                         >
//                           Income
//                         </li>
//                       </ul>
//                     )}
//                   </li>
//                 </ul>
//               </div>
//             </Drawer>
//             <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
//               <DrawerHeader />
//               <div
//                 className={`${
//                   location.pathname === "/login" || location.pathname === "/"
//                     ? "p-4"
//                     : "bg-[#fff] min-h-[80vh]  p-4 m-1 shadow-lg rounded-md transition-all duration-300"
//                 }`}
//               >
//                 {children}
//               </div>
//             </Box>
//           </div>
//         </>
//       )}
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import logo from "../assets/plogo.png";

import { Popover, Transition } from "@headlessui/react";

import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import MedicationIcon from "@mui/icons-material/Medication";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import StorefrontIcon from "@mui/icons-material/Storefront";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import toast from "react-hot-toast";
import Cookies from "js-cookie";

const drawerWidth = 240;
const collapsedWidth = 65;

// Desktop rail: collapses to an icon-only strip, same idea as the first file's DesktopDrawer.
const DesktopDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: open ? drawerWidth : collapsedWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: open
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  }),
  "& .MuiDrawer-paper": {
    width: open ? drawerWidth : collapsedWidth,
    border: "none",
    borderTopRightRadius: 24,
    borderBottomRightRadius: 24,
    background:
      "linear-gradient(160deg, #1e1b2e 0%, #1e1b2e 50%, #2d3a4a 90%, #374151 100%)",
    boxShadow: "6px 0 32px rgba(0,0,0,0.22)",
    overflow: "hidden",
    zIndex: 40,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: open
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
  },
}));

export default function PortalLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px = phones & small tablets

  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [showAccounts, setShowAccounts] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleDrawer = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
    } else {
      setOpen((prev) => !prev);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    Cookies.remove("RVkXIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1L=");
    toast.success("Logout Successfully");
    navigate("/login", { replace: true });
  };

  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    if (email) {
      setUserEmail(email);
    }
  }, []);

  const getPageTitle = () => {
    const map = {
      "/pos": "POS",
      "/products": "Stock",
      "/sales": "Sales",
      "/salesreturn": "Sales Return",
      "/purchases": "Purchases",
      "/suppliers": "Suppliers",
      "/accounts": "Cash Details",
    };
    return map[location.pathname] || "Dashboard";
  };

  // Shared sidebar content — rendered inside either the permanent (desktop)
  // rail or the overlay (mobile) panel.
  const sidebarExpanded = isMobile || open;

  const sidebarContent = (
    <div className="flex flex-col h-full relative">
      {/* Radial ambient overlay */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 20% 15%, rgba(156,163,175,0.18) 0%, transparent 55%), radial-gradient(ellipse at 75% 85%, rgba(107,114,128,0.22) 0%, transparent 55%)",
        }}
      />

      {/* Logo */}
      <div className="relative flex items-center justify-center px-3 pt-5 pb-4 border-b border-white/[0.08] mb-2">
        <img
          src={logo}
          alt="logo"
          className="object-contain transition-all duration-300"
          style={{ width: isMobile ? 72 : open ? 80 : 32 }}
        />
      </div>

      {/* Section label */}
      {sidebarExpanded && (
        <p className="relative text-[10px] font-bold tracking-[1.2px] uppercase text-white/30 px-5 pt-2 pb-1 m-0">
          Navigation
        </p>
      )}

      {/* Nav items */}
      <nav className="relative py-1 flex-1 overflow-y-auto">
        {/* POS */}
        <NavItem
          icon={PointOfSaleIcon}
          label="POS"
          isActive={location.pathname === "/pos"}
          open={sidebarExpanded}
          onClick={() => navigate("/pos")}
        />

        {/* Stock */}
        <NavItem
          icon={MedicationIcon}
          label="Stock"
          isActive={location.pathname === "/products"}
          open={sidebarExpanded}
          onClick={() => navigate("/products")}
        />

        {/* Sales */}
        <NavItem
          icon={PointOfSaleIcon}
          label="Sales"
          isActive={location.pathname === "/sales"}
          open={sidebarExpanded}
          onClick={() => navigate("/sales")}
        />

        {/* Sales Return */}
        <NavItem
          icon={PointOfSaleIcon}
          label="Sales Return"
          isActive={location.pathname === "/salesreturn"}
          open={sidebarExpanded}
          onClick={() => navigate("/salesreturn")}
        />

        {/* Purchases */}
        <NavItem
          icon={ShoppingBagIcon}
          label="Purchases"
          isActive={location.pathname === "/purchases"}
          open={sidebarExpanded}
          onClick={() => navigate("/purchases")}
        />

        {/* Suppliers */}
        <NavItem
          icon={StorefrontIcon}
          label="Suppliers"
          isActive={location.pathname === "/suppliers"}
          open={sidebarExpanded}
          onClick={() => navigate("/suppliers")}
        />

        {/* Cash Details (with submenu) */}
        <div>
          <NavItem
            icon={MedicationIcon}
            label="Cash Details"
            isActive={location.pathname.startsWith("/accounts")}
            open={sidebarExpanded}
            onClick={() => setShowAccounts(!showAccounts)}
            hasSubmenu
            submenuOpen={showAccounts}
          />

          {showAccounts && sidebarExpanded && (
            <ul className="ml-12 mt-1 space-y-1">
              <li
                onClick={() => navigate("/accounts")}
                className={`cursor-pointer text-xs font-bold p-2 pl-4 rounded-md w-[80%] transition-colors duration-200 ${
                  location.pathname === "/accounts"
                    ? "bg-white/20 text-white"
                    : "text-white/50 hover:text-white/80 hover:bg-white/10"
                }`}
              >
                Income
              </li>
            </ul>
          )}
        </div>
      </nav>
    </div>
  );

  if (location.pathname === "/") return children;

  return (
    <div className="flex items-stretch min-h-screen bg-slate-100">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
        * { font-family: 'Plus Jakarta Sans', sans-serif; }
      `}</style>

      <CssBaseline />

      {/* ── SIDEBAR: MOBILE (overlay + slide panel) ──────────────── */}
      {isMobile && (
        <>
          <div
            className="fixed inset-0 z-50 transition-opacity duration-300"
            style={{
              background:     "rgba(0,0,0,0.45)",
              opacity:         mobileOpen ? 1 : 0,
              pointerEvents:   mobileOpen ? "auto" : "none",
              backdropFilter:  mobileOpen ? "blur(2px)" : "none",
            }}
            onClick={() => setMobileOpen(false)}
          />

          <div
            className="fixed top-0 left-0 h-full z-[60] shadow-2xl"
            style={{
              width:      260,
              maxWidth:   "80vw",
              borderTopRightRadius:    24,
              borderBottomRightRadius: 24,
              background:
                "linear-gradient(160deg, #1e1b2e 0%, #1e1b2e 50%, #2d3a4a 90%, #374151 100%)",
              transform:  mobileOpen ? "translateX(0)" : "translateX(-280px)",
              transition: "transform 0.3s cubic-bezier(0.4,0,0.2,1)",
              overflow:   "hidden",
            }}
          >
            <button
              onClick={() => setMobileOpen(false)}
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors z-10"
            >
              <CloseIcon style={{ fontSize: 18, color: "#fff" }} />
            </button>
            {sidebarContent}
          </div>
        </>
      )}

      {/* ── SIDEBAR: DESKTOP (permanent rail) ────────────────── */}
      {!isMobile && (
        <DesktopDrawer variant="permanent" open={open}>
          {sidebarContent}
        </DesktopDrawer>
      )}

      {/* ── MAIN COLUMN ───────────────────────────────────────── */}
      <div
        className="flex flex-col flex-1 min-w-0 transition-all duration-300"
        style={{ minHeight: "100vh" }}
      >
        {/* ── TOP BAR ───────────────────────────────────────────── */}
        <div className="sticky top-0 z-30 px-2 pt-2 pb-0">
          <div className="rounded-2xl border border-white/70 bg-white/85 backdrop-blur-xl shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
            <div className="flex items-center min-h-[56px] px-3 gap-2">

              {/* Menu toggle */}
              <button
                onClick={handleDrawer}
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-700/[0.07] hover:bg-gray-700/[0.14] transition-colors flex-shrink-0"
              >
                <MenuIcon className="!text-[20px] !text-gray-700" />
              </button>

              {/* Page title */}
              <div className="ml-1 min-w-0 flex-1">
                <p className="text-[13px] sm:text-[15px] font-bold text-gray-700 m-0 leading-tight truncate">
                  {getPageTitle()}
                </p>
                <p className="text-[10px] sm:text-[11px] text-gray-400 m-0 hidden xs:block">
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    month:   "short",
                    day:     "numeric",
                  })}
                </p>
              </div>

              {/* Right controls */}
              <div className="ml-auto flex items-center gap-2 sm:gap-3">
                {/* Notification bell */}
                {/* <div className="relative w-9 h-9 hidden sm:flex items-center justify-center rounded-xl bg-gray-700/[0.07] cursor-pointer hover:bg-gray-700/[0.14] transition-colors">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#374151"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                  <span className="absolute top-1.5 right-1.5 w-[7px] h-[7px] rounded-full bg-primary border-[1.5px] border-white" />
                </div> */}

                {/* User chip + dropdown */}
                <Popover className="relative">
                  <Popover.Button
                    as="div"
                    onClick={toggleMenu}
                    className="flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-[6px] rounded-full cursor-pointer select-none
                      bg-gradient-to-r from-gray-700 via-gray-600 to-gray-500
                      shadow-[0_2px_12px_rgba(0,0,0,0.2)]
                      hover:shadow-[0_4px_20px_rgba(0,0,0,0.3)] transition-shadow duration-200"
                  >
                    <AccountCircleIcon className="!text-[20px] !text-white/90" />
                    <IoIosArrowDown
                      className="w-3.5 h-3.5 text-white/70 transition-transform duration-300"
                      style={{ transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)" }}
                    />
                  </Popover.Button>

                  <Transition
                    as={React.Fragment}
                    enter="transition ease-out duration-150"
                    enterFrom="opacity-0 -translate-y-2"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-2"
                  >
                    <Popover.Panel
                      className="absolute top-[calc(100%+10px)] right-0 z-[9999]
                        min-w-[200px] sm:min-w-[220px] rounded-2xl overflow-hidden
                        bg-white/[0.97] backdrop-blur-xl
                        border border-gray-700/10
                        shadow-[0_20px_60px_rgba(0,0,0,0.15)]"
                    >
                      {/* Header */}
                      <div className="flex items-center gap-2.5 p-4 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-500">
                        <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                          <FaRegUser className="text-white text-base" />
                        </div>
                        <div>
                          <p className="text-white/60 text-[11px] m-0">Pharmacy</p>
                        </div>
                      </div>

                      {/* Logout */}
                      <div
                        onClick={handleLogout}
                        className="flex items-center gap-2.5 m-2.5 px-3.5 py-2.5 rounded-xl cursor-pointer
                          bg-gradient-to-r from-red-500 to-red-600
                          text-white font-semibold text-[13px]
                          shadow-[0_3px_12px_rgba(239,68,68,0.3)]
                          hover:-translate-y-px hover:shadow-[0_6px_18px_rgba(239,68,68,0.4)]
                          transition-all duration-200"
                      >
                        <PowerSettingsNewIcon className="!text-[18px]" />
                        <span>Sign Out</span>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </Popover>
              </div>
            </div>
          </div>
        </div>

        {/* ── MAIN CONTENT ──────────────────────────────────────── */}
        <Box component="main" sx={{ flexGrow: 1, p: 0, minWidth: 0 }}>
          <div
            className={`${
              location.pathname === "/login" || location.pathname === "/"
                ? "p-3 sm:p-4"
                : "bg-gradient-to-br from-gray-50 to-gray-100 min-h-[calc(100vh-80px)] p-3 sm:p-4 m-2 rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)] overflow-x-auto"
            }`}
          >
            {children}
          </div>
        </Box>
      </div>
    </div>
  );
}

/* ── Reusable Nav Item ────────────────────────────────────────────────── */
function NavItem({ icon: Icon, label, isActive, open, onClick, hasSubmenu, submenuOpen }) {
  return (
    <div
      onClick={onClick}
      title={!open ? label : ""}
      className={[
        "relative flex items-center cursor-pointer rounded-xl overflow-hidden",
        "mx-2 my-1 px-3 py-2.5",
        "transition-all duration-[250ms] ease-[cubic-bezier(.4,0,.2,1)]",
        isActive
          ? "text-white bg-white/[0.12] shadow-[0_4px_20px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.15)]"
          : "text-white/60 hover:text-white/95 hover:bg-white/[0.08]",
      ].join(" ")}
    >
      {/* Icon wrap */}
      <div
        className={[
          "flex items-center justify-center w-[34px] h-[34px] rounded-[9px] flex-shrink-0 transition-all duration-[250ms]",
          isActive
            ? "bg-primary shadow-[0_4px_14px_rgba(var(--primary-rgb),0.5)]"
            : "bg-white/10 hover:bg-white/[0.16]",
        ].join(" ")}
      >
        <Icon sx={{ fontSize: 18, color: isActive ? "#fff" : "rgba(255,255,255,0.75)" }} />
      </div>

      {/* Label */}
      <span
        className={[
          "ml-3 text-[13.5px] font-semibold whitespace-nowrap overflow-hidden transition-all duration-300 flex-1",
          open ? "max-w-[160px] opacity-100" : "max-w-0 opacity-0",
        ].join(" ")}
      >
        {label}
      </span>

      {/* Submenu arrow */}
      {hasSubmenu && open && (
        <IoIosArrowDown
          className="w-3.5 h-3.5 text-white/50 transition-transform duration-300 ml-auto"
          style={{ transform: submenuOpen ? "rotate(-180deg)" : "rotate(0deg)" }}
        />
      )}

      {/* Active bar */}
      {isActive && (
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[3px] h-[60%] rounded-l bg-primary" />
      )}
    </div>
  );
}